import { isDefined } from '@sgme/fp';
import { IBlotterQuoteItem } from 'models/IBlotterItem';
import { quoteBlotterFiltersLoaded } from 'state/blotters/quote/quoteBlotter.action';
import { IQuoteBlotterFilters } from 'state/blotters/quote/quoteBlotter.model';
import { missedDealFeedbackInitThunk } from 'state/missed-deal-feeedback/thunk';
import { Thunk } from 'state/state.common';
import { getUserSalesDesks } from 'state/user/user.selector';

export function quoteBlotterFiltersLoadedThunk(filters: IQuoteBlotterFilters): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const userSalesDesks = getUserSalesDesks(state);
    if (!userSalesDesks.some(x => x.id === filters.deskFilter)) {
      dispatch(quoteBlotterFiltersLoaded({ ...filters, deskFilter: null }));
    } else {
      dispatch(quoteBlotterFiltersLoaded(filters));
    }
  };
}

export const initFeedbackThunkOnSetActiveItemThunk = (item?: IBlotterQuoteItem): Thunk<void> => {
  return dispatch => {
    if (isDefined(item) && item.status === 'Quoted') {
      dispatch(missedDealFeedbackInitThunk(item.quoteId, item.pricerRfqId));
    }
  };
};
